import type mapboxgl from 'mapbox-gl';

/** Os tipos do `mapbox-gl` sem trazer o módulo: `mapboxgl.Map`, `mapboxgl.Marker`… */
export type * as mapboxgl from 'mapbox-gl';

export type Mapbox = typeof mapboxgl;

let loaded: Mapbox | null = null;
let loading: Promise<Mapbox> | null = null;

/**
 * Carrega o `mapbox-gl` sob demanda (#5796): é a maior dependência do kit e nenhuma
 * tela de abertura desenha mapa. Importado de forma estática, ele entrava inteiro no
 * bundle inicial do web-chat e atrasava o boot de toda abertura. Uma carga por página;
 * chamadas concorrentes compartilham a mesma promise.
 */
export function loadMapbox(): Promise<Mapbox> {
  loading ??= import('mapbox-gl').then(
    (module) => {
      loaded = module.default;
      return loaded;
    },
    (error: unknown) => {
      // Chunk que falhou (rede, deploy que apagou o arquivo): o próximo mapa tenta de novo.
      loading = null;
      throw error;
    },
  );
  return loading;
}

/** O módulo, se já carregado: quem pode nascer agora não espera um tick. */
export function loadedMapbox(): Mapbox | null {
  return loaded;
}

/**
 * O módulo já carregado. Só quem já tem uma instância de mapa chama (marcadores,
 * enquadramento): a instância nasce depois de `loadMapbox` resolver, então o módulo
 * está garantido.
 */
export function mapbox(): Mapbox {
  if (!loaded) throw new Error('mapbox-gl used before loadMapbox() resolved');
  return loaded;
}

/** Volta ao estado de antes da primeira carga, para o teste do mapa que nasce esperando o módulo. */
export function resetMapboxForTests(): void {
  loaded = null;
  loading = null;
}
